import React from 'react';
import { CheckCircle2, Clock, AlertTriangle, XCircle, Database } from 'lucide-react';

/**
 * Badge de estado expresivo con ícono + color semántico.
 * Uso: <StatusBadge status="pagado" /> o <StatusBadge status="pendiente" size="sm" />
 */
const CONFIG = {
  pagado: {
    label: 'Pagado',
    icon: CheckCircle2,
    classes: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  pagada: {
    label: 'Pagado',
    icon: CheckCircle2,
    classes: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  aprobada: {
    label: 'Aprobado',
    icon: CheckCircle2,
    classes: 'bg-blue-50 text-[#2c57c5] border-blue-200',
  },
  aprobado: {
    label: 'Aprobado',
    icon: CheckCircle2,
    classes: 'bg-blue-50 text-[#2c57c5] border-blue-200',
  },
  pendiente: {
    label: 'Pendiente',
    icon: Clock,
    classes: 'bg-amber-50 text-amber-700 border-amber-200',
    dot: 'bg-amber-500',
  },
  rechazada: {
    label: 'Rechazado',
    icon: XCircle,
    classes: 'bg-red-50 text-red-700 border-red-200',
  },
  rechazado: {
    label: 'Rechazado',
    icon: XCircle,
    classes: 'bg-red-50 text-red-700 border-red-200',
  },
  vencido: {
    label: 'Vencido',
    icon: AlertTriangle,
    classes: 'bg-red-100 text-red-800 border-red-300',
  },
  vencida: {
    label: 'Vencido',
    icon: AlertTriangle,
    classes: 'bg-red-100 text-red-800 border-red-300',
  },
  erp: {
    label: 'En ERP',
    icon: Database,
    classes: 'bg-slate-100 text-slate-700 border-slate-300',
  },
  ingresada: {
    label: 'En ERP',
    icon: Database,
    classes: 'bg-slate-100 text-slate-700 border-slate-300',
  },
};

const SIZE_CLASSES = {
  sm: 'text-[10px] px-2 py-0.5',
  md: 'text-[11px] px-2.5 py-1',
};

const ICON_SIZE = { sm: 'h-3 w-3', md: 'h-3.5 w-3.5' };

export default function StatusBadge({ status, size = 'md', label, className = '', 'data-testid': testId }) {
  const key = String(status || '').toLowerCase();
  const cfg = CONFIG[key] || {
    label: label || status || 'N/A',
    icon: null,
    classes: 'bg-slate-50 text-slate-600 border-slate-200',
  };
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 font-semibold rounded-full border ${cfg.classes} ${SIZE_CLASSES[size]} ${className}`}
      data-testid={testId || `status-badge-${key}`}
    >
      {cfg.dot && (
        <span className="relative flex h-1.5 w-1.5">
          <span className={`absolute inline-flex h-full w-full rounded-full ${cfg.dot} opacity-70 animate-ping`} />
          <span className={`relative inline-flex rounded-full h-1.5 w-1.5 ${cfg.dot}`} />
        </span>
      )}
      {Icon && <Icon className={ICON_SIZE[size]} />}
      {label || cfg.label}
    </span>
  );
}
